const maxWidth = {
  mobile: 400,
  tablet: 950,
};

export default maxWidth;